import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { merchant_add, merchant_update, area_list, handle_alarm } from '@/api/jingxiaoshang';
import { area } from '@/api/api_url';
import config from '@/config/index';
export default {
  name: "addAppCustom",
  mixins: [],
  data: function data() {
    return {
      areaData: [],
      defaultList: [],
      defaultList1: [],
      imgName: '',
      visible: false,
      uploadList: [],
      uploadList1: [],
      loading: true,
      formName: 'formValidate',
      modalStatus: this.showModal,
      formValidate: {
        id: [],
        handle_user_name: '',
        handle_user_time: null
      },
      ruleValidate: {
        handle_user_name: [{
          required: true,
          message: this.$t('alarmmenu.handleusernotbenull'),
          trigger: 'blur'
        }],
        handle_user_time: [{
          required: true,
          message: this.$t('alarmmenu.handletimenotbenull'),
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    showModal: {
      handler: function handler(newVal, oldVal) {
        this.modalStatus = newVal;
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: true
    },
    closable: {
      type: Boolean,
      default: false
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: true
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    sticky: {
      type: Boolean,
      default: false
    },
    stickyDistance: {
      type: Number,
      default: 10
    },
    resetDragPosition: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    width: {
      type: Number | String,
      default: 520
    },
    footerHide: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: function _default() {}
    },
    className: {
      type: String,
      default: ''
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    transitionNames: {
      type: Array,
      default: function _default() {
        return ['ease', 'fade'];
      }
    },
    lockScroll: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: false
    },
    beforeClose: {
      type: Function,
      default: function _default() {}
    },
    parent_code: {},
    editModal: {
      type: Boolean,
      default: false
    },
    editData: {},
    ids: {},
    parent_name: {}
  },
  computed: {
    getRoot: function getRoot() {
      var root = '';

      if (process.env.NODE_ENV === 'development') {
        root = config.baseUrl.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.baseUrl.pro;
      } else {
        root = config.baseUrl.alp;
      }

      return root;
    },
    actionUrl: function actionUrl() {
      var root = '';

      if (process.env.NODE_ENV === 'development') {
        root = config.baseUrl.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.baseUrl.pro;
      } else {
        root = config.baseUrl.alp;
      }

      return root + area.certificate_file_upload;
    },
    actionUrl1: function actionUrl1() {
      var root = '';

      if (process.env.NODE_ENV === 'development') {
        root = config.baseUrl.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.baseUrl.pro;
      } else {
        root = config.baseUrl.alp;
      }

      return root + area.facade_pic_upload;
    }
  },
  methods: {
    /**
     * 
     */
    changeTime: function changeTime(val) {
      //  debugger
      this.$set(this.formValidate, 'handle_user_time', val); ///  console.log(this.formValidate) 
    },

    /**
     * 根据area_code，获取级联的code list
     */
    getAreaCodeValue: function getAreaCodeValue(tree, id) {
      var temp = [];

      var forFn = function forFn(arr, id) {
        arr.map(function (item) {
          if (item.area_code === id) {
            temp.unshift(item.area_code); // 按需获取信息(这里是获取节点名称)

            if (item.parent_code) {
              forFn(tree, item.parent_code);
            }
          } else if (item.children.length) {
            forFn(item.children, id);
          }
        });
      };

      forFn(tree, id);
      return temp;
    },
    checkTree: function checkTree(arr) {
      for (var i in arr) {
        arr[i].value = arr[i].area_code;
        arr[i].label = arr[i].area_name;

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    getAreaData: function getAreaData(callback) {
      var _this = this;

      this.areaData.splice(0);
      area_list({
        page: 1,
        page_size: 100,
        parent_code: 1,
        all: 2
      }).then(function (res) {
        if (res.result === 0) {
          var data = res.body.list;

          _this.checkTree(data);

          _this.areaData = data;

          if (callback) {
            callback();
          }
        }
      });
    },
    handleSubmit: function handleSubmit(name) {
      var _this2 = this;

      this.$refs[this.formName].validate(function (valid) {
        if (valid) {
          _this2.$Message.success('Success!');
        } else {
          _this2.$Message.error('Fail!');
        }
      });
    },
    handleReset: function handleReset(name) {
      this.$refs[name].resetFields();
    },

    /**
     * 还原loading状态
     */
    backStatus: function backStatus() {
      var _this3 = this;

      setTimeout(function () {
        _this3.loading = false;

        _this3.$nextTick(function () {
          _this3.loading = true;
        });
      }, 500);
    },

    /**
     * 提交弹窗时
     */
    onOk: function onOk() {
      var _this4 = this;

      this.$refs[this.formName].validate(function (valid) {
        if (valid) {
          _this4.formValidate.id = _this4.ids;
          handle_alarm(_objectSpread({}, _this4.formValidate)).then(function (res) {
            if (res.result === 0) {
              _this4.$Message.success(res.errorMsg);

              _this4.handleReset(_this4.formName);

              _this4.onCancel();

              _this4.$parent.init();
            } else {
              _this4.$Message.error(res.errorMsg);

              _this4.backStatus();
            }
          }).catch(function () {
            _this4.backStatus();
          });
        } else {
          _this4.backStatus();
        }
      });
    },

    /**
     * 取消和关闭弹窗时
     */
    onCancel: function onCancel() {
      this.$parent.addModuleShow();
    },

    /**
     * 开关弹窗时
     */
    onVisibleChange: function onVisibleChange(res) {
      if (res) {} else {
        this.handleReset(this.formName);
        this.$refs.upload.clearFiles();
        this.$refs.upload1.clearFiles();
        this.defaultList1.splice(0);
        this.defaultList.splice(0);
      }
    },
    handleView: function handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      var fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleRemove1: function handleRemove1(file) {
      var fileList = this.$refs.upload1.fileList;
      this.$refs.upload1.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess: function handleSuccess(res, file) {
      console.log(res, file);

      if (res.result === 0) {
        file.url = this.getRoot + res.body.file_url;
        file.name = res.body.file_url;
        this.$set(this.formValidate, 'certificate_url', this.getRoot + res.body.file_url);
      } else {
        this.$set(this.formValidate, 'certificate_url', '');
        this.$Message.error(res.errorMsg);
      }
    },
    handleSuccess1: function handleSuccess1(res, file) {
      console.log(res, file);

      if (res.result === 0) {
        file.url = this.getRoot + res.body.file_url;
        file.name = res.body.file_url;
        this.$set(this.formValidate, 'facade_pic_url', this.getRoot + res.body.file_url);
      } else {
        this.$set(this.formValidate, 'facade_pic_url', '');
        this.$Message.error(res.errorMsg);
      }
    },
    handleFormatError: function handleFormatError(file) {
      this.$Notice.warning({
        title: '图片格式有误',
        desc: '请上传jpg或者png格式的照片'
      });
    },
    handleMaxSize: function handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件过大',
        desc: '文件过大，超出2M.'
      });
    },
    handleBeforeUpload: function handleBeforeUpload() {
      var check = this.uploadList.length < 1;

      if (!check) {
        this.$Notice.warning({
          title: '仅上传一张照片'
        });
      }

      return check;
    },
    handleBeforeUpload1: function handleBeforeUpload1() {
      var check = this.uploadList1.length < 1;

      if (!check) {
        this.$Notice.warning({
          title: '仅上传一张照片'
        });
      }

      return check;
    }
  }
};